import "./Dashboard.css";
import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { BaseURL } from "../../../Hooks/URL";
import PrimaryButton from "../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import FormModal from "../../../Components/Molecules/FormModal/FormModal";
import SettingsForm from "../../../Components/Organisms/Forms/SettingsForm/SettingsForm";
import EditIcon from "@mui/icons-material/Edit";
import { BarLoader } from "react-spinners";

function Dashboard({
  application,
  dashboardData,
  settingsData,
  onUpdateSettings,
  updateSettingsLoading,
  updateState,
}) {
  const [openEditModal, setOpenEditModal] = useState(false);

  useEffect(() => {
    if (
      updateState?.dataRes?.status == "success" &&
      !updateSettingsLoading &&
      openEditModal
    ) {
      setOpenEditModal(false);
    }
  }, [updateState]);

  return (
    <div className="mainContainer">
      <div className="TeacherCont">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <PrimaryButton
            classBtn={"center editButton"}
            startIcon={<EditIcon />}
            text={"Edit Settings"}
            style={{
              textTransform: "capitalize",
              borderRadius: "5px",
              color: "white",
              backgroundColor: "var(--primary)",
              height: "40px",
              padding: "0 20px",
              minWidth: "140px",
            }}
            click={() => setOpenEditModal(true)}
          />
        </div>
        <div className="greyBox">
          <div style={{ width: "100%", textAlign: "center" }}>
            {/* <img
              alt="Logo"
              crossOrigin={"anonymous"}
              className="SchoolLogo"
              src={
                dashboardData?.logo
                  ? `${BaseURL}/images/${dashboardData?.logo}`
                  : ""
              }
            /> */}
            <h2
              style={{
                fontSize: "40px",
                margin: "0 0 10px 0",
                textAlign: "center",
              }}
            >
              Welcome To Registration System
            </h2>
            {/* <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                width: "100%",
                maxWidth: "1200px",
                margin: "auto",
                justifyContent: "space-around",
              }}
            >
              <Box
                sx={{
                  width: {
                    xs: "100%",
                    md: "50%",
                    textAlign: "start",
                    maxWidth: "270px",
                  },
                }}
              >
                <h3
                  style={{
                    fontSize: "20px",
                    margin: "15px 0",
                    textAlign: "center",
                  }}
                >
                  Competition Prices:
                </h3>
                <ul className="confirmList">
                  <li>
                    <span className="listTitle">Currency:</span>{" "}
                    {dashboardData?.currency}
                  </li>
                  <li>
                    <span className="listTitle">Price By Team:</span>{" "}
                    {dashboardData?.pricePerTeamInCents
                      ? dashboardData?.pricePerTeamInCents / 100
                      : "-"}
                  </li>
                  <li>
                    <span className="listTitle">Price By Student:</span>{" "}
                    {dashboardData?.pricePerStudentInCents
                      ? dashboardData?.pricePerStudentInCents / 100
                      : "-"}
                  </li>
                  <li>
                    <span className="listTitle">Price By Groups:</span>{" "}
                    {dashboardData?.competetionPricePerGroups?.length ? (
                      <ul style={{ marginTop: "10px" }}>
                        {dashboardData?.competetionPricePerGroups?.map(
                          (item) => (
                            <li
                              style={{ margin: "0 0 0 15px", fontsize: "8px" }}
                            >
                              - {item?.members} members ={" "}
                              {item?.priceInCents / 100}
                            </li>
                          )
                        )}
                      </ul>
                    ) : (
                      "-"
                    )}
                  </li>
                  <li>
                    <span className="listTitle">Additional Category:</span>{" "}
                    {dashboardData?.additionalCategoryPriceInCents
                      ? dashboardData?.additionalCategoryPriceInCents / 100
                      : "-"}
                  </li>
                  <li>
                    <span className="listTitle">Additional Student:</span>{" "}
                    {dashboardData?.additionalStudentPriceInCents
                      ? dashboardData?.additionalStudentPriceInCents / 100
                      : "-"}
                  </li>
                </ul>
              </Box>
              <Box
                sx={{
                  width: {
                    xs: "100%",
                    md: "50%",
                    textAlign: "start",
                    maxWidth: "270px",
                  },
                }}
              >
                <h3
                  style={{
                    fontSize: "20px",
                    margin: "15px 0",
                    textAlign: "center",
                  }}
                >
                  Competition Rules:
                </h3>
                <ul className="confirmList">
                  <li>
                    <span className="listTitle">Additional Student:</span>{" "}
                    {dashboardData?.additionalStudent ? "True" : "False"}
                  </li>
                  <li>
                    <span className="listTitle">Additional Category:</span>{" "}
                    {dashboardData?.additionalCategory ? "True" : "False"}
                  </li>
                  <li>
                    <span className="listTitle">Pay per:</span>{" "}
                    {dashboardData?.payPerGroup ? "( groups )" : ""}{" "}
                    {dashboardData?.payPerStudent ? "( student )" : ""}{" "}
                    {dashboardData?.payPerTeam ? "( team )" : ""}
                  </li>
                </ul>
              </Box>
              <Box
                sx={{
                  width: {
                    xs: "100%",
                    md: "50%",
                    textAlign: "start",
                    maxWidth: "270px",
                  },
                }}
              >
                <h3
                  style={{
                    textAlign: "center",
                    fontSize: "20px",
                    margin: "15px 0",
                  }}
                >
                  Competition Dates:
                </h3>
                <ul className="confirmList">
                  <li>
                    <span className="listTitle">First Reg. Start Date:</span>{" "}
                    {dashboardData?.startRegisterDate?.split("T")?.at(0)}
                  </li>
                  <li>
                    <span className="listTitle">Second Reg. Start Date:</span>{" "}
                    {dashboardData?.secondStageStartDate?.split("T")?.at(0)}
                  </li>
                  <li>
                    <span className="listTitle">End Reg. Date:</span>{" "}
                    {dashboardData?.endRegisterDate?.split("T")?.at(0)}
                  </li>
                </ul>
              </Box>
            </Box> */}

            {/* Settings Section */}
            {updateSettingsLoading ? (
              <div className="loadingBox" style={{ padding: "20px auto 0" }}>
                <BarLoader color="var(--primary)" />
              </div>
            ) : (
              <Box
                sx={{
                  width: "100%",
                  maxWidth: "1200px",
                  margin: "20px auto 0",
                  padding: "20px",
                  borderRadius: "10px",
                }}
              >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                    gap: "20px",
                  }}
                >
                  <Box>
                    <h4
                      style={{
                        fontSize: "18px",
                        margin: "0 0 15px 0",
                        color: "#333",
                      }}
                    >
                      Deadlines
                    </h4>
                    <ul className="confirmList">
                      <li>
                        <span className="listTitle">
                          Registration Deadline:
                        </span>{" "}
                        {settingsData?.registrationDeadLine
                          ? new Date(
                              settingsData.registrationDeadLine
                            ).toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })
                          : "-"}
                      </li>
                      <li>
                        <span className="listTitle">Edit Deadline:</span>{" "}
                        {settingsData?.editDeadLine
                          ? new Date(
                              settingsData.editDeadLine
                            ).toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })
                          : "-"}
                      </li>
                      <li>
                        <span className="listTitle">Payment Deadline:</span>{" "}
                        {settingsData?.paymentDeadLine
                          ? new Date(
                              settingsData.paymentDeadLine
                            ).toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })
                          : "-"}
                      </li>
                    </ul>
                  </Box>

                  <Box>
                    <h4
                      style={{
                        fontSize: "18px",
                        margin: "0 0 15px 0",
                        color: "#333",
                      }}
                    >
                      Abilities
                    </h4>
                    <ul className="confirmList">
                      <li>
                        <span className="listTitle">Registration Ability:</span>{" "}
                        {settingsData?.registrationAbility ? (
                          <span style={{ color: "green", fontWeight: "600" }}>
                            Enabled
                          </span>
                        ) : (
                          <span style={{ color: "red", fontWeight: "600" }}>
                            Disabled
                          </span>
                        )}
                      </li>
                      <li>
                        <span className="listTitle">Edit Ability:</span>{" "}
                        {settingsData?.editAbility ? (
                          <span style={{ color: "green", fontWeight: "600" }}>
                            Enabled
                          </span>
                        ) : (
                          <span style={{ color: "red", fontWeight: "600" }}>
                            Disabled
                          </span>
                        )}
                      </li>
                      <li>
                        <span className="listTitle">Payment Ability:</span>{" "}
                        {settingsData?.paymentAbility ? (
                          <span style={{ color: "green", fontWeight: "600" }}>
                            Enabled
                          </span>
                        ) : (
                          <span style={{ color: "red", fontWeight: "600" }}>
                            Disabled
                          </span>
                        )}
                      </li>
                    </ul>
                  </Box>
                </Box>
              </Box>
            )}
          </div>
        </div>
      </div>

      {/* Edit Settings Modal */}
      <FormModal
        Open={openEditModal}
        HandleClose={() => setOpenEditModal(false)}
        XButton={true}
        Form={
          <SettingsForm
            onSubmit={(formData) => {
              onUpdateSettings(formData);
            }}
            onCancel={() => setOpenEditModal(false)}
            initialValues={settingsData}
            loading={updateSettingsLoading}
          />
        }
        Title="Edit System Settings"
        CustomStyle="large"
      />
    </div>
  );
}

export default Dashboard;
